<template lang="pug">
	.report-list
		h2.title {{ title }}
		.list
			.list-item(
				v-for='item in list'
				:class='[item.type]'
				@click='action( item )'
			)
				p.text {{ item.text }}
				//- .download-dropdown
				//- 	select
				//- 		option csv
				//- 		option pdf

</template>

<script>
import Dropdown from '@/components/form-inputs/Dropdown';

export default {
	name : 'report-list',

	props : {
		title : String,
		list  : [Array, Object],
	},

	methods : {
		action( item ) {
			const { type, value } = item;

			this.$emit( 'last-click', item );

			switch ( type ) {
				case 'filter':
					this.$emit( 'open-filter', value );
					break;

				case 'download':
					this.$emit( 'download', item );
					break;

				default:
					break;
			}

		}
	},

	components : {
		Dropdown
	}

};
</script>

<style lang="scss">
.report-list {
	margin : 25px 25px;
	flex : 1 1 0;

	.title {
		color : $color-primary;
		margin: 0 10px 20px 10px;
		font-size: 18px;
		letter-spacing: 1px;
	}

	.list {
		display: flex;
		flex-direction: column;
		cursor: pointer;

		.list-item {
			display: flex;
			justify-content: space-between;
			border-radius: 10px;
			transition: box-shadow 0.2s ease;
			box-shadow: none;

			&.unavailable {
				opacity: 0.6;
			}

			.text {
				padding: 10px;
				font-size: 14px;
			}

			&:hover {
				box-shadow: $box-shadow-primary;

				.download-dropdown {
					display: flex;
					opacity: 1;
					pointer-events: all;
				}
			}

			/* No more hover over dropdown
			.download-dropdown {
				background: linear-gradient(90deg, #F3F6FA 0%, rgba(243, 246, 250, 0) 50.72%), #FFFFFF;
				border-bottom-right-radius: 10px;
				border-top-right-radius: 10px;
				opacity: 0;
				pointer-events: none;
			}

			&.download {
				border-radius: 10px;

			}
			*/
		}
	}
}
</style>
